import { ArtworkCostProps } from 'src/components/BundleProduct/ProductBundleSummary/helpers';
import { Customisation as CustomisationType } from 'src/components/BundleProduct/types';
import { ArtworkPriceBreakProps } from 'src/components/BundleProduct/BundleOptionsProvider';

export type Params = {
    artworkCosts: ArtworkCostProps;
    customisation: CustomisationType;
    index: number;
    maxQty: number;
    artworkPriceBreak?: ArtworkPriceBreakProps;
};

export const getCustomisationCost = ({ customisation, artworkCosts, artworkPriceBreak, maxQty, index }: Params) => {
    const artworkCost = artworkCosts[index + 1]; // artworkCost is counting from 1
    const filteredPrices = artworkPriceBreak?.customisation_estimates.filter(
        (estimate) => maxQty >= estimate.min_qty && estimate.type === Number(customisation.selectedMethod),
    );
    const regularPrice = (filteredPrices?.[filteredPrices?.length - 1].price || 0) * maxQty;

    if (!artworkCost)
        return {
            regularPrice,
            finalPrice: 0,
            fee: 0,
        };

    return {
        regularPrice,
        finalPrice: artworkCost.price * maxQty,
        fee: artworkCost.fee,
    };
};
